export default "__VITE_ASSET__ByOlIpy6__"